export enum InternalAccessor {
  Disabled = '_disabled',
  HoverActions = '_hoverActions',
  Readonly = 'readonly', // It can be combined with `UrlExternal` or `UrlInternal` to make row not clickable */
  SectionHeader = '_sectionHeader', // Renders the row as a section title inside the table. Read from row data, so it needs no column
  StaticActions = '_staticActions',
  SubRow = '_subRow',
  UrlExternal = '_urlExternal',
  UrlInternal = '_urlInternal',
}
